const BASE_ROUTE = '/';
const PRICING_ROUTE = `${BASE_ROUTE}pricing`;
const PRICING_ROUTE_DEFAULT = `${BASE_ROUTE}pricing/ES_SH`;
const COSTING_ROUTE = `${BASE_ROUTE}costing`;
const COSTING_ROUTE_DEFAULT = `${BASE_ROUTE}costing/es`;
const TENDER_ROUTE = `${BASE_ROUTE}tender`;
const LOGIN_ROUTE = `${BASE_ROUTE}login`;
const LOGOUT_ROUTE = `${BASE_ROUTE}logout`;

export {
  BASE_ROUTE,
  PRICING_ROUTE,
  PRICING_ROUTE_DEFAULT,
  COSTING_ROUTE,
  COSTING_ROUTE_DEFAULT,
  LOGIN_ROUTE,
  LOGOUT_ROUTE,
  TENDER_ROUTE
};
